import React, { useEffect, useState } from 'react';
import { ConfigContext } from './ConfigContext';

import { setConfig } from './configService';

export const ConfigProvider = ({ children }) => {
  const [appConfig, setAppConfig] = useState(null);

  useEffect(() => {
    const loadConfig = async () => {
      try {
        const res = await fetch('/deployment-config.json', {
          cache: 'no-store',
        });

        if (!res.ok) {
          throw new Error('Failed to load config');
        }

        const data = await res.json();
        const normalizedAppConfig = {
          apiUrl: data.API_URL,
          idScanLicenseKey: data.ID_SCAN_LICENSE_KEY,
          smartyStreetsWebsiteKey: data.SMARTYSTREETS_WEBSITE_KEY,
          smartyStreetEnforce: data.SMARTYSTREETS_ENFORCE,
          envLabel: data.ENV_LABEL,
          isSmartyAutofillDisabled: data.IS_SMARTY_AUTOFILL_DISABLED,
          disableManualUpload: data.DISABLE_MANUAL_UPLOAD,
          websocketUrl: data.WEBSOCKET_URL,
          verificationInterval: data.VERIFICATION_INTERVAL,
          isSmartyStreetsDisabled: data.IS_SMARTY_STREETS_DISABLED,
          pageSenseId: data.PAGESENSE_ID,
          idScanTimeout: data.ID_SCAN_TIMEOUT,
          recaptchaSiteKey: data.RECAPTCHA_SITE_KEY,
        }
        setConfig(normalizedAppConfig);
        setAppConfig(normalizedAppConfig)
      } catch (err) {
        console.error('Config load error:', err);
        setConfig({});
        setAppConfig({});
      }
    };

    loadConfig();
  }, []);

  if (appConfig === null) {
    return null;
  }

  return (
    <ConfigContext.Provider value={appConfig}>
      {children}
    </ConfigContext.Provider>
  );
};
